module.exports = __webpack_public_path__ + "img/HelloMusicLogo.0a6af305.png";